import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  margin: auto;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  max-width: 400px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center !important;
  padding: 5px;
  margin-top: 70px;
`

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  padding: 10px;
`

export const Image = styled.img`
  width: 110px;
  margin-bottom: 10px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
`

export const LinkText = styled(Link)`
  color: #35A7FF;
  font-size: 16px;
  text-decoration: none;
  margin-top: 5px;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin-top: 10px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0px 10px;
  padding: 0px;
`

export const Label = styled.p`
  font-size: 16px;
  margin-bottom: 5px;
`

export const WarningText = styled.p`
  margin: 2px 0px 0px;
  color: #FF3939;
  text-align: center;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-top: 15px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`